import { motion } from "framer-motion";

export const SectionHeading = ({ eyebrow, title, description, align = "left", testId }) => {
  const alignment = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`flex flex-col gap-4 ${alignment}`}
      data-testid={testId}
    >
      <span className="font-mono text-xs tracking-[0.25em] uppercase text-signal">{eyebrow}</span>
      <h2 className="font-display text-3xl md:text-5xl tracking-tight font-semibold text-white">{title}</h2>
      {description && <p className="text-muted text-base md:text-lg leading-relaxed max-w-2xl">{description}</p>}
    </motion.div>
  );
};
